import { Component, Input } from '@angular/core';
var HTML_TEMPLATE = "\n<div  class=\"od-icon-link\" [ngClass]=\"{'od-icon-link-disabled':disabled,'clickable':_clickable}\">\n\t<div *ngIf=\"_iconName !=null\" [ngStyle]=\"{'color':_color,'font-size':_size+'px', 'font-weight':_iconWeight, 'opacity': _iconOpacity }\" [class]=\"_iconName +' od-icon-link-icon'\" [textContent]=\"_counter\"></div>\n\t<div class=\"od-icon-link-text\" [ngStyle]=\"{'color':_fontColor}\" [textContent]=\"_text\"></div>\n</div>";
var CSS_STYLE = "\n.od-icon-link{\n\tdisplay: inline-flex;\n    justify-content: center;\n    outline-width: 0;\n    flex-shrink: 0;\n    flex-grow: 0;\n    white-space: nowrap;\n    padding: 4px;\n}\n\n.od-icon-link-icon:before{\n\tpadding-right: 4px;\n}\n\n.od-icon-link-icon + .od-icon-link-text{\n   padding-left: 4px;\n   padding-bottom: 4px;\n}\n\n.od-icon-link-text {\n\tflex-grow:1;\n\talign-self: flex-end;\n\tfont-size: 13px;\n}\n\n.od-icon-link.clickable:not(.od-icon-link-disabled){\n\tcursor: pointer;\n}\n\n.od-icon-link.clickable:not(.od-icon-link-disabled):hover{\n\tfilter: brightness(80%);\n}\n\n.od-icon-link-disabled {\n\topacity: 0.5;\n\tpointer-event:none;\n}\n";
var IconLink = /** @class */ (function () {
    function IconLink() {
        this._iconWeight = 'normal';
        this._iconOpacity = 1.0;
        this.text = "";
        this.counter = "";
        this.color = "#1d9ac0";
        this.size = 16;
        this.disabled = false;
    }
    Object.defineProperty(IconLink.prototype, "text", {
        set: function (value) {
            if (value != null)
                this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "counter", {
        set: function (value) {
            this._counter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "iconName", {
        set: function (value) {
            this._iconName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "iconFontWeight", {
        set: function (value) {
            this._iconWeight = value + ' !important';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "iconOpacity", {
        set: function (value) {
            this._iconOpacity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "color", {
        set: function (value) {
            if (value != null) {
                this._color = value;
                if (this._fontColor == null)
                    this._fontColor = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "fontColor", {
        set: function (value) {
            this._fontColor = (value == null) ? this._color : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "size", {
        set: function (value) {
            if (value != null)
                this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconLink.prototype, "clickable", {
        set: function (value) {
            this._clickable = value;
        },
        enumerable: true,
        configurable: true
    });
    IconLink.decorators = [
        { type: Component, args: [{
                    selector: 'od-icon-link',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    IconLink.ctorParameters = function () { return []; };
    IconLink.propDecorators = {
        "disabled": [{ type: Input },],
        "text": [{ type: Input },],
        "counter": [{ type: Input },],
        "iconName": [{ type: Input },],
        "iconFontWeight": [{ type: Input },],
        "iconOpacity": [{ type: Input },],
        "color": [{ type: Input },],
        "fontColor": [{ type: Input },],
        "size": [{ type: Input },],
        "clickable": [{ type: Input },],
    };
    return IconLink;
}());
export { IconLink };
//# sourceMappingURL=icon-link.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/button/icon-link.js
// module id = 420
// module chunks = 14